import type { LngLat } from './geo'
import type { Sport } from './models'
import { SPORTS } from './models'

/** Compact route-plan share links: #r=<sport>:<lng,lat;lng,lat;...> (5-decimal precision). */

export function encodePlanUrl(waypoints: readonly LngLat[], sport: Sport): string {
  const pts = waypoints.map((w) => `${w[0].toFixed(5)},${w[1].toFixed(5)}`).join(';')
  return `${location.origin}/#r=${sport}:${pts}`
}

export function decodePlanHash(hash: string): { waypoints: LngLat[]; sport: Sport } | null {
  const m = hash.match(/#r=([a-z]+):([0-9.,;-]+)/)
  if (!m) return null
  const sport = SPORTS.find((s) => s.id === m[1])?.id
  if (!sport) return null
  const waypoints: LngLat[] = []
  for (const pair of m[2].split(';')) {
    const [lng, lat] = pair.split(',').map(Number)
    if (!Number.isFinite(lng) || !Number.isFinite(lat) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null
    waypoints.push([lng, lat])
  }
  return waypoints.length >= 2 ? { waypoints, sport } : null
}
